import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FilterTab from '../../components/common/FilterTab';
import FourGrid from '../../components/icons/FourGrid';
import { useAdvanceTableContext } from '../../providers/AdvanceTableProvider';
import { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const MachinesTopSection = ({ activeView }) => {
  const navigate = useNavigate();
  const { setGlobalFilter, getPrePaginationRowModel, getColumn } =
    useAdvanceTableContext();

  const handleFilterItemClick = (columnId, value) => {
    const column = getColumn(columnId);
    column?.setFilterValue(value === 'all' ? '' : value);
  };

  const tabItems = useMemo(() => {
    const getDataCount = label =>
      getPrePaginationRowModel().rows.filter(
        ({ original: { status } }) => status.label === label
      ).length;

    return [
      {
        label: 'All',
        value: 'all',
        onClick: () => handleFilterItemClick('status', 'all'),
        count: getPrePaginationRowModel().rows.length
      },
      {
        label: 'Running',
        value: 'running',
        onClick: () => handleFilterItemClick('status', 'running'),
        count: getDataCount('running')
      },
      {
        label: 'Stopped',
        value: 'stopped',
        onClick: () => handleFilterItemClick('status', 'stopped'),
        count: getDataCount('stopped')
      },
      {
        label: 'Inactive',
        value: 'inactive',
        onClick: () => handleFilterItemClick('status', 'inactive'),
        count: getDataCount('inactive')
      }
    ];
  }, [getPrePaginationRowModel]);

  const handleSearchInputChange = e => {
    setGlobalFilter(e.target.value || undefined);
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-4">
      <Col xs={12} sm="auto">
        <FilterTab tabItems={tabItems} />
      </Col>
    </Row>
  );
};

export default MachinesTopSection;
